<template>
    <div class="detail">
        <!-- 头部 -->
        <navbar-header></navbar-header>

        <!-- 背景 -->
        <div class="bg_box"></div>

        <!-- 新闻详情 -->
        <study-detail-box :info="info" :MuLuList="MuLuList" :TuiJianArray="tuijian" :isZan="isZan" :isCollect="isCollect" @update="updateNews" v-if="info.subId"></study-detail-box>

        <!-- 登录框 -->
        <div class="login_box" v-if="NeedLogin">
            <div class="container">
                <div class="top_bg">
                    <div class="bar_box">
                        <img src="../assets/static/login/dl_01.png" alt="">
                    </div>
                    <div class="name_box">
                        <img src="../assets/static/login/dl_03.png" alt="">
                    </div>
                    <div class="close_box" @click="closePage">
                        <img src="../assets/static/login/dl_04.png" alt="">
                    </div>
                </div>
                <div class="input_box">
                    <img src="../assets/static/login/log_ico01.png" alt="">
                    <input type="text" class="finp" v-model="UserInfo.phone" placeholder="请输入手机号码">
                </div>
                <div class="input_box">
                    <img src="../assets/static/login/log_ico02.png" alt="">
                    <input type="password" class="finp" v-model="UserInfo.password" placeholder="请输入密码">
                </div>
                <div class="input_box">
                    <img src="../assets/static/login/log_ico03.png" alt="">
                    <input type="text" class="code" v-model="checkCode" placeholder="请输入验证码">
                    <div class="code_box" >
                        <YanZhenMa @getResultCode="getCode"  ref="yzm" />
                    </div>
                </div>
                <div class="btn_box" @click="login" >
                    登录
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
import { JSEncrypt } from 'jsencrypt'
import YanZhenMa from "@/components/common/YanZhenMa"
    const decrypt = new JSEncrypt()
    import NavbarHeader from "../components/index/NavbarHeader"
    import NavFooter from "../components/common/NavFooter"
    import StudyDetailBox from "../components/redSchool/StudyDetailBox"
    import { mapGetters } from "vuex"
    export default {
        components: {
            NavbarHeader,
            NavFooter,
            StudyDetailBox,
            YanZhenMa,
        },
        computed: {
            school_id () {
                return Number( this.$route.params.id )
            },

            ...mapGetters(['token'])
        },
        watch: {
            school_id () {
                this.getNewsDetail()
                if ( this.token ) {
                    this.getNewsFavStatus()
                }
            }
        },
        data() {
            return {
                UserInfo: {
                    phone: "",
                    password: ""
                },
                info: {},
                dialogVisible: false,
                nextInfo: {},
                preInfo: {},
                isZan: 0, 
                isCollect: 0,
                tuijian: [],
                timer: "",
                second: 0,
                MuLuList:[],
                publicKey: null,
                checkCode: null,
                resultCode: null,
                NeedLogin: false,
            }
        },
        created () {
            
            if ( this.token ) {
                this.getNewsDetail()
                this.getNewsFavStatus()
            } else {
                this.auth()
            }
        },
        mounted() {
            this.timeCount()
            this.onWindowClose()
        },
        beforeRouteLeave (to, from, next) {
            console.log("离开")
            this.SaveUserStudyTime()
            next()
        },
        methods: {
            // 关闭登录页面返回首页
            closePage() {
                this.$router.push("/")
            },
             // 点击登录
            async login () {
                await this.getPublicKey()
                let { phone, password, checkCode, publicKey, resultCode } = this 
                if ( !phone ) {
                    return this.$message.error("请输入手机号码")
                } else if ( !password ) {
                    return this.$message.error("请输入密码")
                } else if ( !checkCode ) {
                    return this.$message.error("请输入验证码")
                } else if ( checkCode != resultCode ) {
                    return this.$message.error("验证码错误")
                } else if ( !publicKey ) {
                    return this.$message.error("为获取到公钥")
                } else {
                    password = decrypt.encrypt( password ) // 密码加密
					phone = decrypt.encrypt( phone )
                    let res = await this.$axios.post("/lencon/pc/login/login", { phone, password, publicKey })
                    this.$refs.yzm.randomNUmber()
                    if ( res.data.code == 1 ) {
                        this.$message.success( res.data.msg )
                        let token = res.data.token 
                        localStorage.setItem("token", token)
                        this.$store.commit("getToken", token )
                        this.$router.push("/")
                    } else {
                        this.$message.error( res.data.msg )
                    }
                }
            },
            // 获取验证码
            getCode ( code ) {
                // console.log( code )
                this.resultCode = code 
            },
            cancelLogin() {
                this.dialogVisible = false 
                window.history.forward(-1);
                this.$router.replace("/")
                
            },
              // 获取publickKey
            async getPublicKey () {
                let res = await this.$axios.post("/lencon/pc/login/getPublicKey")
                console.log( res )
                if ( res.data.code == 1 ) {
                    this.publicKey = res.data.publicKeyString
                    decrypt.setPublicKey( this.publicKey );
                }
            },
            // 点击登录
            async login () {
                await this.getPublicKey()
                let { phone, password } = this.UserInfo
                let { publicKey } = this 
                if ( !phone ) {
                    return this.$message.error("请输入手机号码")
                } else if ( !password ) {
                    return this.$message.error("请输入密码")
                } else if ( !publicKey ) {
                    return this.$message.error("未获取到公钥")
                } else {
                    password = decrypt.encrypt( password ) // 密码加密
					phone = decrypt.encrypt( phone )
                    let res = await this.$axios.post("/lencon/pc/login/login", { phone, password, publicKey })
                    // this.$refs.yzm.randomNUmber()
                    this.dialogVisible = false
                    if ( res.data.code == 1 ) {
                        this.$message.success( res.data.msg )
                        let token = res.data.token 
                        localStorage.setItem("token", token)
                        this.$store.commit("getToken", token )
                        this.$router.push("/")
                    } else {
                        this.$message.error( res.data.msg )
                    }
                }
            },
            // 是否登录
            auth () {
                if ( this.token ) {
                    return true 
                } else {
                    this.NeedLogin = true
                }
            },
            // 窗口关闭
            onWindowClose () {
                window.addEventListener("beforeunload", () => { this.SaveUserStudyTime() })
            },
             // 进入后进入计时状态
            timeCount () {
                if ( !this.token ) {
                    return false
                }
                console.log("计时开始")
                this.timer = setInterval(() => {
                    this.second ++
                }, 1000);
            },
            // 保存用户的学习时间]
            async SaveUserStudyTime () {
                let { token, school_id, second } = this
                if ( this.token ) {
                    console.log( "保存学习时间" + this.second )
                    let res = await this.$axios.post("/lencon/pc/school/saveLearnTimeLength", { token, school_id, minLenTime:second })
                    // this.$message.info( res.data.msg )
                    this.second = 0
                    clearInterval( this.timer )
                }
            },
            // 获取新闻详情
            async getNewsDetail () {
                let info = {}
                let { token, school_id } = this 
               
                let res = await this.$axios.post("/lencon/pc/school/schoolSubZjLists", { token, subId:school_id  })
                if ( res.data.code == 1 ) {
                    this.info = res.data.obj
                    this.MuLuList =  res.data.data
                }
            },

            // 新闻收藏状态
            async getNewsFavStatus () {
                let { token, school_id } = this 
                let res = await  this.$axios.post("/lencon/pc/school/is_collection", { token, school_id })
                if ( res.data.code == 1 ) {
                    this.isCollect = res.data.is_collection
                    console.log("收藏" + this.isCollect )
                }

            },
    
            // 更新新闻
            updateNews () {
                this.getNewsDetail()
                this.getNewsFavStatus()
                // this.getNewsZanStatus()
            }
        }
    }
</script>

<style lang="scss" scoped>
.detail {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        margin: 0 auto;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 300px;
        z-index: -1;
    }
}

.login_box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.6);
    z-index: 1000000000;
    .container {
        width: 500px;
        height: 510px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -250px;
        margin-top: -255px;
        background-color: #fff;
        border-radius: 10px;
        .input_box {
                width: 400px;
                height: 60px;
                margin: 30px auto;
                box-sizing: border-box;
                // border-radius: 30px;
                overflow: hidden;
                border-bottom: 1px solid #DBDBDB;
                display: flex;
                position: relative;
                left: 0;
                top: 0;
                img {
                    position: absolute;
                    left: 15px;
                    top: 15px;
                    width: 30px;
                    height: 30px;
                    line-height: 60px;
                }
                .finp {
                    width: 100%;
                    height: 60px;
                    outline: none;
                    border: none;
                    padding: 0 20px 0 60px;
                    line-height: 60px;
                    background-color: transparent;
                }
                .code {
                    border: none;
                    outline: none;
                    width: 300px;
                    padding: 0 20px 0 60px;
                    background-color: transparent;
                }
            }
            .btn_box {
                width: 400px;
                height: 60px;
                background: #D10D19;
                box-shadow: 0px 5px 10px 0px rgba(144, 138, 135, 0.15);
                border-radius: 30px;
                border: none;
                outline: none;
                margin: 20px auto;
                text-align: center;
                line-height: 60px;
                color: #fff;
                cursor: pointer;
                font-size: 26px;
                letter-spacing: 10px;
                font-weight: bold;
                
            }
            .top_bg {
                width: 100%;
                height: 100px;
                border-radius:10px 10px 0 0;
                background: url(../assets/static/login/dl_02.png) 0 0 no-repeat;
                background-size: 100% 100%;
                position: relative;
                left: 0;
                top: 0;
                .bar_box {
                    position: absolute;
                    left: -36px;
                    bottom: 0;
                }
                .close_box {
                    position: absolute;
                    right: 10px;
                    top: 10px;
                    cursor: pointer;
                }
                .name_box {
                    width: 100%;
                    height: 100px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
    }
    
}
</style>